import { Link, NavLink } from "react-router";
import { FiCompass, FiHome, FiUsers } from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import AccountMenu from "./AccountMenu";
import ThemeToggle from "./ThemeToggle";

export default function AppNavigation() {
  const { userId, authLoading } = useAuth();
  const tabs = userId ? [["/explore", "Explore", FiCompass]] : [["/", "Home", FiHome], ["/explore", "Explore", FiCompass]];
  if (userId) tabs.push(["/courses", "My Groups", FiUsers]);
  return <header className="sticky top-0 z-30 border-b border-gray-200 bg-white">
    <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-6 gap-y-2 px-4 pt-3 sm:px-6">
      <Link to={userId ? "/explore" : "/"} className="text-lg font-bold text-gray-950">CoachHub</Link>
      <nav aria-label="Main navigation" className="order-3 flex w-full gap-5 sm:order-none sm:w-auto">
        {tabs.map(([to, label, Icon]) =>
          <NavLink key={to} to={to} end className={({ isActive }) => `flex min-h-12 items-center gap-2 border-b-2 text-sm font-semibold ${isActive ? "border-orange-700 text-orange-800" : "border-transparent text-gray-600 hover:text-gray-950"}`}><Icon aria-hidden="true" />{label}</NavLink>)}
      </nav>
      <div className="ml-auto flex items-center gap-2 pb-2">{!userId && <ThemeToggle />}{userId ? <AccountMenu /> : !authLoading ? <Link to="/login" className="inline-flex min-h-10 items-center rounded-md bg-orange-700 px-4 text-sm font-semibold text-white hover:bg-orange-800">Log in</Link> : <div className="h-10 w-20" />}</div>
    </div>
  </header>;
}
